import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from 'src/store/hooks';
import { queryParams } from "src/helpers/UrlHelpers";
import { fetchUsers } from "src/actions/callrecorder/usersActions";

import PageLayout from '../_partials/PageLayout';
import Edit from "./Edit";
import ListTable from "./_partials/_ListTable";
import PageHeader from "src/componets/PageHeader";

const LIMIT = 42;

const Users = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;
  const { pathname } = useLocation();

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'search_by', 'order_by', 'order', 'provider_id', 'bundle_id', 'verified', 'suspicious']
    );

    dispatch(fetchUsers(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  return (
    <PageLayout className='v-users'>
      <PageHeader title='Users' />

      <div className='v-container'>
        <ListTable limit={LIMIT} />
      </div>

      <Edit />
    </PageLayout>
  );
}

export default Users;
